import React, { useState, useEffect } from 'react';
import { FooterStyled } from '../styles/layOutStyles';

import NoticeBanner from './banner/NoticeBanner';
import { Grid } from '@material-ui/core';
import { TextBox } from '../styles/globalStyles';

import { storageData, getStorageInfoData, getStorageNoticeData } from '../constants/index';

import { FOOTERMENU } from './Menu';
import { useHistory } from 'react-router-dom';

const Footer = () => {
  const history = useHistory();
  const [data, setData] = useState('');
  const [noticeData, setNoticeData] = useState([]);

  const goLink = url => {
    history.push(process.env.PUBLIC_URL + `${url}`);
  };

  useEffect(() => {
    setData(getStorageInfoData('company'));
    setNoticeData(getStorageNoticeData());
  }, [storageData]);

  return (
    <React.Fragment>
      <NoticeBanner data={noticeData} />
      <FooterStyled>
        <Grid container item xs={8} style={{ alignItems: 'center', justifyContent: 'center' }}>
          <Grid item xs={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <img src='/assets/Ftv/Ftv_Logo.png' alt='footer_logo' style={{ width: '53%', height: '100%', objectFit: 'cover' }} />
          </Grid>
          <Grid container item xs={10}>
            <Grid item container xs={12} style={{ color: '#FFFFFF', justifyContent: 'flex-start', alignItems: 'center' }}>
              {FOOTERMENU.map((item, idx) => {
                return (
                  <TextBox key={`footer_${idx}`} style={{ margin: '12px 35px', cursor: 'pointer' }} onClick={() => goLink(item.pathname)}>
                    {item.label}
                  </TextBox>
                );
              })}
            </Grid>
            <Grid item container xs={12} style={{ color: '#777777', flexDirection: 'column', padding: '0 24px' }}>
              <Grid style={{ marginBottom: '12px' }}>
                {data?.addr} &nbsp; | &nbsp; 대표이사 {data?.ceo}
              </Grid>
              <Grid style={{ marginBottom: '20px' }}>
                Tel. {data?.tel} &nbsp; | &nbsp; Fax. {data?.fax} &nbsp; | &nbsp; 이메일. {data?.email} &nbsp; | &nbsp; 사업자등록번호 :
                {data?.businessNumber} &nbsp; | &nbsp; 통신판매업신고 : {data?.license1}
              </Grid>
              <Grid style={{ color: '#555555' }}>Copyright © 2013 한국낚시채널 Co, Ltd, All Right Reserved.</Grid>
            </Grid>
          </Grid>
        </Grid>
      </FooterStyled>
    </React.Fragment>
  );
};

export default React.memo(Footer);
